import React from "react";
import TenantForm from "./TenantForm";

export default function AddTenant() {

  return (
    <TenantForm type="Add" />
  );
}
